import { jsx as _jsx } from "react/jsx-runtime";
import { _className, Button, ComponentSync, openContent } from '@nu-art/thunderstorm-frontend';
import { Component_ContentFallback } from '../../Component_ContentFallback/Component_ContentFallback.js';
import './Component_EventFeedButton.scss';
import { ModuleFE_AdvisorMini } from '../../../../modules/ModuleFE_AdvisorMini.js';
import { PanelKey_EventFeed, PanelKey_Home } from '@app/advisor-v5-shared';
import { ICONS } from '@app/styles';
import { ModuleFE_AdvisorAnalytics } from '../../../../_analytics/consts.js';
import { ModuleFE_AdvisorSession } from '@app/advisor-frontend';
import { ModuleFE_RuntimeEncounterFeed } from '../../../../modules/runtime/index.js';
import { Board_EventFeed } from '../../../../_enum.js';
export class Component_EventFeedButton extends ComponentSync {
    //######################### Life Cycle #########################
    __onAdvisorMiniChange = () => {
        if (this.mounted)
            this.forceUpdate();
    };
    __onAdvisorBoardUpdated = (updates) => {
        if (this.mounted)
            this.forceUpdate();
    };
    deriveStateFromProps(nextProps, state) {
        state.forceFallback = !!nextProps.forceFallback;
        return state;
    }
    //######################### Logic #########################
    onClick = async () => {
        let open = true;
        if (ModuleFE_AdvisorMini.getIsMiniActive()) {
            if (ModuleFE_AdvisorMini.getCurrentFocusedPanel() !== PanelKey_EventFeed)
                ModuleFE_AdvisorMini.openPanel(PanelKey_EventFeed);
            else {
                ModuleFE_AdvisorMini.openPanel(PanelKey_Home);
                open = false;
            }
        }
        else {
            if (!Board_EventFeed.isOpen())
                Board_EventFeed.open();
            else {
                Board_EventFeed.close();
                open = false;
            }
        }
        if (open) {
            const deltaCount = ModuleFE_RuntimeEncounterFeed.cache.all().length;
            ModuleFE_AdvisorAnalytics.trigger.eventLog.eventLog_opened({ deltaCount });
        }
        else {
            this.forceUpdate();
        }
    };
    isActive = () => {
        if (ModuleFE_AdvisorMini.getIsMiniActive())
            return ModuleFE_AdvisorMini.getCurrentFocusedPanel() === PanelKey_EventFeed;
        return Board_EventFeed.isOpen();
    };
    //######################### Render #########################
    render() {
        const advisorConfig = ModuleFE_AdvisorSession.getAdvisorConfig();
        if (!advisorConfig?.catchUp?.recap)
            return;
        const className = _className('c__event-feed-button', 'c__utility-button', this.isActive() && 'active');
        return _jsx(Button, { className: className, variant: 'primary', onClick: this.onClick, ...(this.state.forceFallback && openContent.tooltip.top('tt__event-feed-button', 'Events', { offset: 10 })), children: _jsx(Component_ContentFallback, { forceFallback: this.state.forceFallback, content: () => 'Events', fallback: () => _jsx(ICONS.advisor_avn_bell.component, {}) }) });
    }
}
//# sourceMappingURL=Component_EventFeedButton.js.map